import React from 'react';
import Select from './Select';

interface Props {
    currentLanguage: string;
    handleChangeLanguage: (lang: string) => void;
    languageList: string[];
}

const LanguageSelect: React.FC<Props> = ({
    currentLanguage,
    handleChangeLanguage,
    languageList,
}) => {
    return (
        <Select
            value={currentLanguage}
            setFieldValue={handleChangeLanguage}
            selectItems={languageList}
        />
    );
};

export default LanguageSelect;
